var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DeleteOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.92913 3.21373H7.71484C7.8327 3.21373 7.92913 3.1173 7.92913 2.99944V3.21373H16.072V2.99944C16.072 3.1173 16.1684 3.21373 16.2863 3.21373H16.072V5.1423H18.0006V2.99944C18.0006 2.05391 17.2318 1.28516 16.2863 1.28516H7.71484C6.76931 1.28516 6.00056 2.05391 6.00056 2.99944V5.1423H7.92913V3.21373ZM21.4291 5.1423H2.57199C2.09788 5.1423 1.71484 5.52534 1.71484 5.99944V6.85659C1.71484 6.97444 1.81127 7.07087 1.92913 7.07087H3.54699L4.20859 21.0798C4.25145 21.9932 5.00681 22.7137 5.9202 22.7137H18.0809C18.997 22.7137 19.7497 21.9959 19.7925 21.0798L20.4541 7.07087H22.072C22.1898 7.07087 22.2863 6.97444 22.2863 6.85659V5.99944C22.2863 5.52534 21.9032 5.1423 21.4291 5.1423ZM17.8747 20.7852H6.12645L5.47824 7.07087H18.5229L17.8747 20.7852Z",
    fill: "#096DD9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/DeleteOutlined.b70a48d4a53c2e6e092191b89910dc2e.svg";
export { ForwardRef as ReactComponent };